import {Component, Input, OnInit} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {BoardColumnProvider} from 'src/app/providers';
import {Subject} from 'rxjs';
import {Router} from '@angular/router';
import {Board, BoardColumn} from '../../../model/board';
import {BoardService} from '../../../services';

@Component({
  selector: 'create-new-board-column-modal',
  templateUrl: './create-new-board-column.modal.html',
  styleUrls: ['./create-new-board-column.modal.scss']
})
export class CreateNewBoardColumnModal implements OnInit {

  private boardSub: any;
  isEdit = false;
  boardColumn: BoardColumn = new BoardColumn();
  board: Board;
  subject: Subject<Board>;
  constructor(
    public bsModalRef: BsModalRef,
    private boardService: BoardService,
    private router: Router,
    private boardColumnProvider: BoardColumnProvider
  ) { }

  ngOnInit(): void {
    this.board = new Board();
    this.boardSub = this.boardService.currentBoard$.subscribe(board => this.board = board);
  }

  ngOnDestroy(): void {
    if(this.boardSub) this.boardSub.unsubscribe();
  }

  onSubmit(): void {
    this.boardColumnProvider.saveBoardColumn(this.board.ID, this.boardColumn)
      .subscribe(
        data => {
          if (data.success) {
            this.bsModalRef.hide();
            this.subject.next(data.result);
          }
        });
  }

  onCancel(): void {
    this.bsModalRef.hide();
  }
}
